/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {StepModal} from './components/stepModal'
import {StepperComponent} from '../../../../../../../../../_metronic/assets/ts/components'
import {useToast} from '../../../../../../../components/Toats'
import {KTSVG} from '../../../../../../../../../_metronic/helpers'
import {LoadingSpan} from '../../../../../../../components/Loadings/loadingSpan'
import {postEmailsUC, updateEmailUC} from '../../../../../../../../services/emailRedirectUCService'

type DataForm = {
  email: string | null
}

type Props = {
  id?: string
  data?: DataForm
  show: boolean
  idUnitConsumer: string
  handleClose: () => void
}

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required('Informe um e-mail. '),
})

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalAddUpdateEmail = ({show, handleClose, data, id, idUnitConsumer}: Props) => {
  const {toggleToast} = useToast()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)

  const [initialValues, setInitialValues] = useState<DataForm>({
    email: null,
  })
  const [hasError, setHasError] = useState(false)
  const [myError, MyError] = useState(false)
  const [loading, setLoading] = useState(false)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const checkInputs = (): boolean => {
    if (!formik.values.email) {
      return false
    }
    return true
  }

  const closed = () => {
    setHasError(false)
    formik.setValues(initialValues)
    handleClose()
  }

  const postEmailSubmit = async () => {
    try {
      setLoading(true)
      const myData = {
        email: formik.values.email,
        idUnitConsumer: idUnitConsumer ? idUnitConsumer : '',
      }
      await postEmailsUC(myData)
      toggleToast('Sucesso ao cadastrar o e-mail ', 'success')
    } catch (error) {
      console.log('erro', error)
      toggleToast('Erro ao cadastrar o e-mail. ', 'error')
    } finally {
      setLoading(false)
      closed()
    }
  }

  const updateEmailSubmit = async (id: string) => {
    try {
      setLoading(true)
      const myData = {
        email: formik.values.email,
      }
      await updateEmailUC(myData, id)
      toggleToast('Sucesso ao atualizar e-mail ', 'success')
    } catch (error) {
      console.log('erro', error)
      toggleToast('Erro ao atualizar e-mail ', 'error')
    } finally {
      setLoading(false)
      closed()
    }
  }

  const submit = () => {
    if (id) {
      updateEmailSubmit(id)
    } else {
      postEmailSubmit()
    }
  }

  const nextStep = () => {
    setHasError(false)
    if (!stepper.current) {
      return
    }
    if (!checkInputs()) {
      setHasError(true)
      return
    }
    submit()
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: nextStep,
  })

  useEffect(() => {
    if (data) {
      const myObject = {
        email: data.email ? data.email : null,
      }
      formik.setValues(myObject)
    } else {
      formik.setValues(initialValues)
    }
  }, [show])

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-600px'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>
            {id ? 'Editar' : 'Adicionar'} e-mail{' '}
          </span>
          {/* <span className='text-muted mt-1 fw-semibold fs-5'>( {unitBranch.name} )</span> */}
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={closed}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
          <div className='flex-row-fluid py-lg-1 px-lg-2'>
            <form noValidate id='kt_modal_create_app_form'>
              <StepModal data={initialValues} hasError={hasError} formik={formik} />
            </form>
          </div>
        </div>
      </div>

      <div className='modal-footer'>
        <div className='d-flex flex-stack' style={{justifyContent: 'end'}}>
          <div style={{display: 'flex', gap: '1rem'}}>
            <button
              type='button'
              className='btn btn-lg btn-primary'
              disabled={loading}
              //data-kt-stepper-action='submit'
              onClick={nextStep}
            >
              {id ? 'Editar' : 'Cadastrar'}{' '}
              {loading ? (
                <LoadingSpan style={{marginLeft: '0.5rem'}} />
              ) : (
                <KTSVG
                  path='/media/icons/duotune/arrows/arr064.svg'
                  className='svg-icon-3 ms-2 me-0'
                />
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalAddUpdateEmail}
